import React, { useEffect, useState } from 'react';

const useButtonsGroup = (reset, afterClick, initProcent = '10%') => {
  const [clickedValue, setClickedValue] = useState('');
  const [customValue, setCustomValue] = useState('');
  const [placeholder, setPlaceholder] = useState(initProcent);
  const [active, setActive] = useState(false);
  const handleClick = (val: string) => {
    setClickedValue(val);
    setActive(false);
    afterClick(val);
  };

  useEffect(() => {
    if (reset) {
      setClickedValue('');
      setCustomValue('');
      setActive(false);
      setPlaceholder(initProcent);
      afterClick('');
    }
  }, [reset]);

  const onBlurHandler = (e: React.SyntheticEvent<any>) => {
    e.currentTarget.textContent = '';
    const value = customValue === '' ||  customValue=='NaN';
    setPlaceholder( value ? initProcent : customValue + '%');
    setCustomValue('');
  };

  const onChangeValue = (event) => {
    const {
      target: { value }
    } = event;
    setCustomValue(value);
  };

  useEffect(() => {
    if (customValue &&  customValue!=='NaN') {
      setClickedValue(customValue);
      afterClick(customValue);
    }
  }, [customValue]);

  return {
    active,
    setActive,
    customValue,
    clickedValue,
    placeholder,
    handleClick,
    onBlurHandler,
    onChangeValue
  };
};

export default useButtonsGroup;
